import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import saveAs from 'file-saver';
import Veiculo from "model/gestao/frotas/Veiculo";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ManutencaoVeiculoService from "service/gestao/frotas/ManutencaoVeiculoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const manutencaoVeiculoService = new ManutencaoVeiculoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ManutencaoVeiculoListagem() {

    const [queryParameters] = useSearchParams();

    const { msgErro } = useToastContext();

    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);

    const [titulo, setTitulo] = useState<string>('Manutencões');

    const [editaRelatorio, setEditaRelatorio] = useState<boolean>(false);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);

    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        manutencaoVeiculoService.veiculosDisponiveis().then(data => setVeiculos(data)).catch(erro => console.log(erro));

        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setEditaRelatorio(usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_MANUTENCAO_LISTAGEM"));
        }).catch((erro) => {
            console.log(erro);
        });
    }, [])

    const statusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={manutencaoVeiculoService.getStatusManutencaoVeiculoFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    const tipoFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={manutencaoVeiculoService.getTipoManutencaoVeiculoFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    const defaultFilters: DataTableFilterMeta = {
        tipo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },

        dataManutencao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },

        veiculo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        valorTotal: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const veiculoFilterTamplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={veiculos} filter
            onChange={(e) => options.filterCallback(e.value)}
            itemTemplate={(item: Veiculo) => item.identificador + ' - ' + item.modelo}
            valueTemplate={(item: Veiculo) => item ? item.identificador + ' - ' + item.modelo : 'Escolha um veículo'}
            optionLabel={"modelo"} optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const botoesExtra = () => {
        const model = [{ label: "Editar relatórios", icon: "pi pi-pencil", command: () => setVisibleEditarRelatorio(true) }];
        if (!editaRelatorio) {
            return [<Button key="btn2" label="Relatório" onClick={() => getRelatorio()} icon="pi pi-file-pdf" style={{ marginRight: '8px' }} />]
        }
        return [<SplitButton
            style={{ marginRight: '8px' }}
            key="btn2"
            label="Relatório"
            onClick={() => getRelatorio()}
            icon="pi pi-file-pdf"
            model={model}

        />]
    }

    const dialogEditarRelatorio = (
        <Dialog header="Editar relatório" visible={visibleEditarRelatorio} onHide={() => setVisibleEditarRelatorio(false)} >
            {editaRelatorio ? <ReportEdit nomeAcao="RELATORIO_MANUTENCAO_LISTAGEM" titulo="Relatório de Manutenção" testarRelatorio={() => { }} style={{ marginBottom: 10 }} /> : null}
        </Dialog>
    )

    const getRelatorio = () => {
        startLoading();
        manutencaoVeiculoService.getRelatorio(filters).then((response) => {
            stopLoading();
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "RelatorioManutencaoListagem.pdf");
        }).catch((err) => {
            stopLoading();
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        })
    }

    return (
        <>
            {dialogEditarRelatorio}
            <BaseListagem
                buttonsExtra={botoesExtra()}
                ordenacao="dataManutencao,DESC" service={manutencaoVeiculoService} urlService="/manutencaoVeiculo" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="manutencaoVeiculo"
                onChangeFilters={(filters) => setFilters(filters)}>
                <Column field="tipo" header="Tipo" body={(rowData) => manutencaoVeiculoService.getTipo(rowData.tipo)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={tipoFilterTemplate} />

                <Column field="dataManutencao" header="Data" body={(rowData) => converterData(rowData.dataManutencao)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />

                <Column field="veiculo.identificador" header="Veiculo" body={(rowData) => rowData.veiculo.identificador + " - " + rowData.veiculo.modelo} style={{ width: '40%' }} filterField="veiculo"
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={veiculoFilterTamplate} />

                <Column field="valorTotal" header="Valor" body={(rowData) => rowData.valorTotal ? "R$" + rowData.valorTotal.toFixed(2) : "R$0,00"} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate} />

                <Column field="status" header="Status" body={(rowData) => manutencaoVeiculoService.getStatus(rowData.status)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={statusFilterTemplate} />
            </BaseListagem>
        </>

    )
}